import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';

import { DataFlowStream } from 'app/model/dataflow/transformation';
import { DataFlowExpression } from './dataflowexpression';
import { Owned } from '../base/named';

@Metamodel.model({
    name: 'splitConditionExpression'
})
export class SplitConditionExpression extends Owned {
    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        display: stringResources.OutputStreamLabel,
        reference: true,
        constraint: {
            required: true
        }
    })
    public outputStream: DataFlowStream;

    @Metamodel.attribute({
        display: stringResources.Expression
    })
    public dataFlowExpression?: DataFlowExpression;

    @Metamodel.attribute({
        display: stringResources.Default
    })
    public isDefault: boolean;
}
